/* version.js */ function _(require, module, exports) {
    exports.version = '1.4.0';
}
